const module_edit = {
  namespaced: true,
  state: {
    is_show: false
  },
  mutations: {
    SET_show(state, val) {
      state.is_show = val
    }
  },
  actions: {}
}
export default module_edit
